export type BoschUiStickerType =
  | 'primary'
  | 'secondary'
  | 'contrast'
  | 'turquoise'
  | 'purple'
  | 'green'
  | 'yellow'
  | 'blue'
  | 'red';
